import PropTypes from 'prop-types';
import React from 'react';

import {
  TileWithLoading,
  tileWithLoadingPropTypes,
} from '@react/Pages/AccountSettingsPage/YourDataSection/TileWithLoading';
import ProgressRadial from './ProgressRadial';

const UserEntry = ({ role, totalUsers }) => (
  <div className="flex-one">
    <ProgressRadial count={role.count} total={totalUsers} extraClasses={role.extraClass} />
    <div className="center">{role.title}</div>
  </div>
);

const UsersTileBase = ({ rolesCount, totalUsers, href }) => {
  const roleEntries = [
    {
      title: t('role.admin'),
      extraClass: 'progress-radial--admin',
      count: rolesCount.admin,
    },
    {
      title: t('role.editor'),
      extraClass: 'progress-radial--editor',
      count: rolesCount.editor,
    },
    {
      title: t('role.reader'),
      extraClass: 'progress-radial--reader',
      count: rolesCount.reader,
    },
    {
      title: t('role.custom'),
      extraClass: 'progress-radial--custom',
      count: rolesCount.custom,
    },
  ];

  const renderFields = roleEntries.map(role => <UserEntry key={role.title} role={role} totalUsers={totalUsers} />);

  return (
    <>
      <div className="your-data-card__title">{t('label.users')}</div>
      <div className="your-data-card__body your-data-card__body--centered">
        <div className="flex-one flex-box-row users-container">{renderFields}</div>
      </div>
      <a className="your-data-card__action" href={href}>
        <i className="icon-show" />
      </a>
    </>
  );
};

const UsersTile = TileWithLoading(UsersTileBase);

UsersTileBase.propTypes = {
  rolesCount: PropTypes.shape({
    admin: PropTypes.number,
    editor: PropTypes.number,
    reader: PropTypes.number,
    custom: PropTypes.number,
  }),
  totalUsers: PropTypes.number,
  href: PropTypes.string,
};

UserEntry.propTypes = {
  role: PropTypes.shape({
    title: PropTypes.string,
    extraClass: PropTypes.string,
    count: PropTypes.number,
  }),
  totalUsers: PropTypes.number,
};

UsersTile.propTypes = {
  ...UsersTileBase.propTypes,
  ...tileWithLoadingPropTypes,
};

export default UsersTile;
export { UsersTile, UsersTileBase };
